// @ts-nocheck
import { Card, CircularProgress, IconButton, withStyles } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import RefreshIcon from '@material-ui/icons/Autorenew';
import { Entity, ctx as L20NContext } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { BLUE } from '../../_config/consts';
import * as WearableActions from '../../redux/actions/wearable.actions';
import * as UtilsActions from '../../redux/actions/utils.actions';
import SimpleExportMenu from '../ExportMenus/SimpleExportMenu.jsx';
import ChartMultilineIconCustom from '../CustomIcons/ChartMultilineIconCustom.jsx';

const styles = theme => ({
  card: {
    padding: 20,
    marginBottom: 15,
    position: 'relative',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 15,
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    width: 50,
    color: '#3f3f3f',
    marginRight: 15,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#3f3f3f',
    margin: 0,
  },
  subtitle: {
    fontSize: 14,
    color: '#757575',
    margin: 0,
    marginTop: 5,
  },
  emptyState: {
    textAlign: 'center',
    padding: 40,
    color: '#757575',
  },
  tableCard: {
    marginTop: 20,
    borderRadius: 12,
    overflow: 'hidden',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.07), 0 1px 3px rgba(0, 0, 0, 0.06)',
    border: '1px solid #e8e8e8',
  },
  tableContainer: {
    maxHeight: 500,
    overflowY: 'auto',
    overflowX: 'auto',
  },
  table: {
    minWidth: 650,
  },
  tableHead: {
    backgroundColor: '#f8f9fa',
  },
  tableHeadRow: {
    borderBottom: '2px solid #dee2e6',
  },
  tableHeadCell: {
    borderRight: '1px solid #dee2e6',
    borderBottom: '2px solid #dee2e6',
    padding: '16px',
    '&:last-child': {
      borderRight: 'none',
    },
  },
  tableCell: {
    borderRight: '1px solid #e8e8e8',
    borderBottom: '1px solid #e8e8e8',
    padding: '14px 16px',
    '&:last-child': {
      borderRight: 'none',
    },
  },
  tableRow: {
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: '#f5f7fa',
    },
    '&:last-child td': {
      borderBottom: 'none',
    },
  },
  tableColumnText: {
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    color: '#495057',
    margin: 0,
  },
  tableCellText: {
    fontSize: 14,
    color: '#212529',
    fontWeight: 400,
    margin: 0,
  },
  refreshHeader: {
    display: 'flex',
    alignItems: 'center',
  },
  refreshIcon: {
    fontSize: 30,
  },
  progress: {
    margin: 0,
    marginTop: 0,
    padding: 0,
    left: '50%',
    position: 'absolute',
    height: '38px !important',
    width: '38px !important',
    zIndex: 10000,
  },
});

const EmptyHistoryView = () => (
  <div style={{ height: 100, flexDirection: 'column', margin: 20, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <ChartMultilineIconCustom style={{ color: '#bdbdbd', width: 35 }} />
    <h3 style={{ color: '#bdbdbd', fontWeight: 'bold', marginTop: 0, fontSize: 18 }}><Entity entity="noHistoryFound" /></h3>
  </div>
);

@connect((state) => ({
  history: state.wearables.history.content,
  pagination: state.wearables.history.pagination,
  filters: state.wearables.history.filters,
}))
class WearableTrackingHistoryView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      lastUpdate: moment().valueOf(),
      dateRange: {
        startDate: moment().subtract(1, 'M').startOf('day'),
        endDate: moment().add(1, 'd').endOf('day'),
      },
    };
  }

  async componentDidMount() {
    await this.onFetchHistory();
  }

  async onFetchHistory() {
    const { dispatch, wearable } = this.props;
    if (!wearable || !wearable.id) return;
    
    try {
      this.setState({ isLoading: true });
      await dispatch(WearableActions.fetchWearableHistory(wearable.id));
      this.setState({ 
        isLoading: false,
        lastUpdate: moment().valueOf(),
      });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  }

  onFilterDateRange(startDate, endDate) {
    const { dispatch } = this.props;
    if (startDate && endDate) {
      const fromDate = startDate.valueOf();
      const toDate = endDate.valueOf();
      dispatch(WearableActions.setWearableHistoryFilter('fromDate', fromDate));
      dispatch(WearableActions.setWearableHistoryFilter('toDate', toDate));
      this.setState({ 
        dateRange: { startDate, endDate } 
      });
      setTimeout(() => {
        this.onFetchHistory();
      }, 300);
    }
  }

  onDateRangeChange({ startDate, endDate }) {
    this.setState({ 
      dateRange: { startDate, endDate } 
    });
    if (startDate && endDate) {
      this.onFilterDateRange(startDate, endDate);
    }
  }

  async onExportHistory(format) {
    const { dispatch, wearable } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      await dispatch(WearableActions.exportWearableHistory(wearable.id, format));
      dispatch(UtilsActions.setSpinnerVisibile(false));
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
    }
  }

  render() {
    const { classes, wearable, history, filters } = this.props;
    const { isLoading, lastUpdate, dateRange } = this.state;
    const displayHistory = history
    
    return (
      <div>
        <Card className={classes.card} elevation={2} style={{ opacity: isLoading ? 0.5 : 1, height: '120vh' }}>
          <div className={classes.header}>
            <div className={classes.headerLeft}>
              <ChartMultilineIconCustom className={classes.icon} />
              <div>
                <h3 className={classes.title}><Entity entity="locationHistory" /></h3>
                <p className={classes.subtitle}><Entity entity="locationHistoryDescription" /></p>
              </div>
            </div>
            <div className={classes.refreshHeader}>
              <h5 style={{ color: '#3f3f3f', margin: 0, marginRight: 10 }}>
                <Entity entity="lastUpdate" />: {moment(lastUpdate).format('LLL')}
              </h5>
              <IconButton
                disabled={isLoading}
                style={{ opacity: isLoading ? 0.5 : 1 }}
                onClick={() => this.onFetchHistory()}
              >
                <RefreshIcon className={classes.refreshIcon} style={{ color: BLUE }} />
              </IconButton>
            </div>
          </div>

          {displayHistory && !_.isEmpty(displayHistory) && (
            <SimpleExportMenu
              titleContainerStyle={{ marginLeft: 10 }}
              numberOfElements={_.size(displayHistory)}
              onExportLogs={format => this.onExportHistory(format)}
            />
          )}

          <Card className={classes.tableCard} elevation={3}>
            <div className={classes.tableContainer}>
              {displayHistory && !_.isEmpty(displayHistory) ? (
                <Table className={classes.table}>
                  <TableHead className={classes.tableHead}>
                    <TableRow className={classes.tableHeadRow}>
                      <TableCell className={classes.tableHeadCell}>
                        <h5 className={classes.tableColumnText}>
                          <Entity entity="dateAndTime" />
                        </h5>
                      </TableCell>
                      <TableCell className={classes.tableHeadCell}>
                        <h5 className={classes.tableColumnText}>
                          {'HyperGate'}
                        </h5>
                      </TableCell>
                      <TableCell className={classes.tableHeadCell}>
                        <h5 className={classes.tableColumnText}>
                          {'RSSI'}
                        </h5>
                      </TableCell>
                      <TableCell className={classes.tableHeadCell}>
                        <h5 className={classes.tableColumnText}>
                          <Entity entity="emergency" />
                        </h5>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {_.map(displayHistory, (event, index) => (
                      <TableRow key={index} className={classes.tableRow}>
                        <TableCell className={classes.tableCell}>
                          <span className={classes.tableCellText}>
                            {event.timestamp ? moment(event.timestamp).format('LLL') : '---'}
                          </span>
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          <span className={classes.tableCellText}>
                            {event.gateway && event.gateway.name ? event.gateway.name : '---'}
                          </span>
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          <span className={classes.tableCellText}>
                            {event.rssi ? event.rssi : '---'}
                          </span>
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          <span className={classes.tableCellText}>
                            {event.emergency ? L20NContext.getSync('yes') : L20NContext.getSync('no')}
                          </span>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              ) : <EmptyHistoryView />}
            </div>
          </Card>
          {isLoading ? <CircularProgress color="primary" className={classes.progress} /> : null}
        </Card>
      </div>
    );
  }
}

export default withStyles(styles)(WearableTrackingHistoryView);
